/* eslint-disable react/jsx-key */
import React, { PropsWithChildren } from 'react'
import Masonry from 'react-masonry-css'
import LogoList from '../../components/LogoList'
import LogoListCard from '../../components/LogoList/LogoListCard'
import styles from './logoGrid.module.scss'

export type ItemType = {
  component?: 'logo_grid_item'
  link?: {
    cached_url?: string
    fieldtype?: string
    id?: string
    linkType?: string
  }
  logo?: {
    alt?: string
    copyright?: string
    fieldtype?: string
    filename?: string
    id?: number
    name?: string
    title?: string
  }
  text?: string
  newtab?:string
  _editable?: string
  _uid?: string
}

export type LogoLinkType = {
  cached_url: string
  id: string
  linktype: string
  fieldtype: string
}

export type LogoGridType = {
  component?: 'logo_grid'
  logos: ItemType[]
  title: string
  light_bg: boolean
  link?: LogoLinkType
}

export const LogoGridColumns = {
  default: 6,
}

export const LogoGridContainer: React.FC = ({ children }) => (
  <section className={styles.container}>
    <div className={styles.cardContainer}>
      {children}
    </div>
  </section>
)

export const LogoGrid: React.FC<PropsWithChildren<{ slice: LogoGridType }>> = ({ slice }) => styles.masonryGalleryGrid ? (
  <LogoGridContainer>
    <LogoList light_bg={slice.light_bg} data={slice.logos} title={slice.title}>
      <Masonry
        breakpointCols={LogoGridColumns}
        className={styles.masonryGalleryGrid}
      >
        {slice?.logos && slice?.logos?.length > 0 && slice?.logos?.map((item, idx) => (<LogoListCard key={idx} card={item} light_bg={slice.light_bg} />))}
      </Masonry>
    </LogoList>
  </LogoGridContainer>
) : null

export default LogoGrid
